import React                                                from 'react'
import Box                                                  from '@material-ui/core/Box'
import Grid                                                 from '@material-ui/core/Grid'
import { Link }                                             from '@material-ui/core'
import PropTypes                                            from 'prop-types'
import Typography                                           from '@material-ui/core/Typography'

const ClassNoteShowComponent = ( props ) => {

   const { collapseNote, note, numNotes } =  props

   const handleCollapseNote = () => {
      collapseNote(true)
   }


   const showOnlyNote = note.note.map( (n,i) => {
      return (
         <Grid key={i} >
            <Typography align='left' style={{ marginBottom: '0.5rem' }} >
               {n}
            </Typography>
         </Grid>
      )
   })

   return (
      <Box>
         <Grid>
            <Grid>
               {numNotes > 1
                  ?
                     <Typography variant='h5' align='left' style={{ marginBottom: '0.5rem' }} onClick={handleCollapseNote} >
                        { note.noteTitle } (click to collapse)
                     </Typography>

                  :
                     <Typography variant='h5' align='left' style={{ marginBottom: '0.5rem' }} >
                        { note.noteTitle }
                     </Typography>
               }
            </Grid>
            { showOnlyNote }
            <Grid>
               <Typography align='left' style={{ marginBottom: '0.5rem' }} >
                  <Link href={note.noteLink} target='_blank' rel='noopener noreferrer' >
                     { note.noteLink }
                  </Link>
               </Typography>
            </Grid>
         </Grid>
      </Box>
)
}

ClassNoteShowComponent.propTypes = {
   collapseNote: PropTypes.func,
   note: PropTypes.object,
   numNotes: PropTypes.number
}

export default ClassNoteShowComponent